import React, {useState} from 'react';
import DynaInput from "../../DynaView/DynaInput";
import DynaCaptcha from "../../DynaView/DynaCaptcha";

const StepLogin = ({sendData, setSendData, textCaptcha, setTextCaptcha}) => {

  const [renderCaptcha, setRenderCaptcha] = useState(0);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <DynaInput label={"نام کاربری"}
                 name={"user"}
                 className={"solid-dyna-input"}
                 placeholder={"نام کاربری خود را وارد کنید"}
                 value={sendData?.user}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />

      <div className={"row-pass"}>
        <DynaInput label={"رمز عبور"}
                   name={"pass"}
                   className={"solid-dyna-input"}
                   placeholder={"رمز عبور خود را وارد کنید"}
                   value={sendData?.pass}
                   type={showPassword ? 'text' : 'password'}
                   setDataFromComponent={(data) => {
                     setSendData({...sendData, ...data})
                   }}
        />
        <button className={"show-hidden"} onClick={togglePasswordVisibility}>
          {showPassword ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              className="eye"
              fill="#B9B9B9"
              viewBox="0 0 576 512">
              <path
                d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 11288 0 144 144 0 11-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z"></path>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              className="eye-slash"
              fill="#B9B9B9"
              viewBox="0 0 640 512">
              <path
                d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-105.2-82.4c39.6-40.6 66.4-86.1 79.9-118.4 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm184.3 144.4c25.5-23.3 59.6-37.5 96.9-37.5 79.5 0 144 64.5 144 144 0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3 0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1-79.5 0-144-64.5-144-144 0-6.9.5-13.6 1.4-20.2l-94.3-74.3c-22.8 29.7-39.1 59.3-48.6 82.2-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47 43.8 111.7 80.6 192.5 80.6 47.8 0 89.9-12.9 126.2-32.5L373 389.9z"></path>
            </svg>
          )}
        </button>
      </div>


      <div className="captcha-box">
        <DynaCaptcha length={6}
                     fontSize={20}
                     textColor={"#2C496B"}
                     renderCaptcha={renderCaptcha}
                     setTextCaptcha={setTextCaptcha}/>

        <div className="reload-captcha" onClick={() => setRenderCaptcha(renderCaptcha + 1)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              fill="#3F74FF"
              d="M12 22.75c-5.2 0-9.42-4.23-9.42-9.42C2.58 8.14 6.8 3.9 12 3.9c1.07 0 2.11.15 3.11.46.4.12.62.54.5.94a.75.75 0 01-.94.5c-.85-.26-1.75-.4-2.67-.4-4.37 0-7.92 3.55-7.92 7.92s3.55 7.92 7.92 7.92a7.925 7.925 0 006.59-12.32.746.746 0 01.21-1.04c.34-.23.81-.14 1.04.21a9.366 9.366 0 011.59 5.24c-.01 5.19-4.23 9.42-9.43 9.42z"
            ></path>
            <path
              fill="#3F74FF"
              d="M16.13 6.07c-.21 0-.42-.09-.57-.26l-2.89-3.32a.756.756 0 01.07-1.06c.31-.27.79-.24 1.06.07l2.89 3.32c.27.31.24.79-.07 1.06-.13.13-.31.19-.49.19z"
            ></path>
            <path
              fill="#3F74FF"
              d="M12.76 8.53c-.23 0-.46-.11-.61-.31-.24-.33-.17-.8.16-1.05l3.37-2.46a.752.752 0 01.89 1.21L13.2 8.39a.7.7 0 01-.44.14z"
            ></path>
          </svg>
        </div>
        <div className={"line-on-text"}></div>
        <button className={"auto-captcha"}
                onDoubleClick={() => setSendData({...sendData, captchaInput: textCaptcha.toLowerCase()})}></button>
      </div>

      <DynaInput label={"حروف تصویر"}
                 name={"captchaInput"}
                 className={"solid-dyna-input"}
                 placeholder={"حروف تصویر خود را وارد کنید"}
                 value={sendData?.captchaInput.toUpperCase()}
                 type={"text"}
                 style={{fontFamily: "Trebuchet MS"}}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />
    </>
  );
};

export default StepLogin;